var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.991 3.689A7.178 7.178 0 0110 1.667c1.879 0 3.68.727 5.008 2.022a6.816 6.816 0 012.075 4.881c0 1.831-.746 3.587-2.074 4.882l-4.66 4.541a.5.5 0 01-.698 0l-4.66-4.541a6.895 6.895 0 01-1.535-2.24 6.751 6.751 0 010-5.284 6.894 6.894 0 011.535-2.24zM10 10.543a2.05 2.05 0 001.43-.578c.38-.37.594-.872.594-1.395s-.214-1.024-.593-1.394A2.05 2.05 0 0010 6.598a2.05 2.05 0 00-1.431.578c-.38.37-.593.871-.593 1.394 0 .523.213 1.025.593 1.395.38.37.894.578 1.43.578z",
    fill: "#0EA546"
  })));
}

export default SvgSource;